import { Pipe, PipeTransform } from '@angular/core'
import dayjs from 'dayjs'

import { dateFormats } from '@core/constants/dateFormats'

@Pipe({
  name: 'dayjsFullTime',
  standalone: false,
})
export class DayjsFullTimePipe implements PipeTransform {
  transform(date?: string): string {
    return date ? dayjs(date).tz().format(dateFormats.fullTime) : null
  }
}
